'use client';

import { Box, freddyTheme, Typography } from '@coolblue-development/freddy';
import { useTranslation } from '@i18n/useTranslation';
import { getCommunityTranslationKey } from '@utils/businessUtils/getCommunityTranslationKey';

const NotPartOfCommunityAlert = ({ closedCommunityType }: { closedCommunityType: string }) => {
  const { t } = useTranslation('webshop.business.communities');

  const communityTypeLabel = t(getCommunityTranslationKey(closedCommunityType));

  return (
    <Box
      p={300}
      sx={{
        backgroundColor: freddyTheme.color.background.secondary,
        border: `${freddyTheme.borderWidth[25]} solid ${freddyTheme.color.border.secondary}`,
        borderRadius: freddyTheme.borderRadius[100]
      }}
    >
      <Typography>{t('notPartOfYourCommunity', { communityType: communityTypeLabel })}</Typography>
    </Box>
  );
};

export default NotPartOfCommunityAlert;
